import type { SectionId } from "../domain/types";
import { FACET_QUARTER_ART } from "../config/artAssets";

const shared = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';

export const NAV_ICONS: Record<SectionId, string> = {
  core: `<svg ${shared}><path d="M12 2.8 18.5 7l-2.4 9.5L12 21.2l-4.1-4.7L5.5 7 12 2.8Z"/><path d="m5.5 7 6.5 3 6.5-3M12 10v11"/></svg>`,
  development: `<svg ${shared}><path d="m5 19 5.2-5.2M14.5 5.5l4 4M13 7l4 4-7.5 7.5-4-4L13 7Z"/><path d="m4 20 3-1-2-2-1 3Z"/></svg>`,
  progress: `<svg ${shared}><path d="M8 4h8v4a4 4 0 0 1-8 0V4Z"/><path d="M8 6H4v1a4 4 0 0 0 4 4M16 6h4v1a4 4 0 0 1-4 4M12 12v5M8 21h8M9 17h6"/></svg>`,
  friends: `<svg ${shared}><circle cx="9" cy="8" r="3"/><circle cx="17" cy="9" r="2.3"/><path d="M3.5 19c.4-4 2.2-6 5.5-6s5.1 2 5.5 6M15 14c3 0 4.7 1.7 5 5"/></svg>`,
  games: `<svg ${shared}><circle cx="12" cy="12" r="8"/><path d="m12 4 2.6 3.4L13 11h-4L7.4 7.4 12 4ZM9 11l-3 2.2 1 4M13 11l5 2.2-1 4M8 19h8"/></svg>`,
};

export const CLOSE_ICON = `<svg ${shared}><path d="m6 6 12 12M18 6 6 18"/></svg>`;
export const CHEVRON_ICON = `<svg ${shared}><path d="m9 6 6 6-6 6"/></svg>`;
export const CURRENCY_ICON = `<img class="currency-mark currency-mark--diamond" src="${FACET_QUARTER_ART.diamond.base.url}" alt="" width="${FACET_QUARTER_ART.diamond.base.width}" height="${FACET_QUARTER_ART.diamond.base.height}" aria-hidden="true" draggable="false"/>`;

export const SEASON_ICON = `<svg class="season-mark" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
  <circle cx="12" cy="12" r="8.25"/>
  <path d="M12 7.3v5l3.35 2.05"/>
  <path d="M12 1.7v1.55M12 20.75v1.55M1.7 12h1.55M20.75 12h1.55"/>
</svg>`;

export function sectionIcon(section: SectionId): string {
  return NAV_ICONS[section];
}

export function closeIcon(): string {
  return CLOSE_ICON;
}

export function currencyIcon(): string {
  return CURRENCY_ICON;
}

export function seasonIcon(): string {
  return SEASON_ICON;
}
